import React from 'react'
import api from '../../../../utils/api'
import {notifySuccess} from '../../../../utils/notifications'
import handleError from '../../../../utils/handleError'
import {translate as tl} from '../../../../utils/translation'

const PayoffCancel = (props) => {
  const handleClick = async () => {
    const {row, updateTable, page} = props
    const data = {
      status: 'canceled'
    }
    try {
      const response = await api(`/cashback/payoffs/${row._id}`, 'PUT', null, data)
      notifySuccess(response.data.message)
      updateTable({page})
    } catch (error) {
      handleError(error, props)
    }
  }

  return (
    <a className='col-red'>
      <i className='material-icons' style={{'cursor': 'pointer'}} title={tl('backend_action_payoff_cancel')} onClick={(e) => { handleClick() }}>euro_symbol</i>
    </a>
  )
}
export default PayoffCancel
